import { createTheme } from '@mui/material/styles';

// Temp
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#0E35D1',
    },
  },
  typography: {
    fontFamily:
      'Raleway,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji',
    body2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '18px',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          letterSpacing: 0,
          textTransform: 'none',
        },
      },
    },
  },
});
